import {
  GET_LABREQUESTTRACKING_FAIL,
  GET_LABREQUESTTRACKING_SUCCESS,
  GET_LABREQUESTTRACKINGS_FAIL,
  GET_LABREQUESTTRACKINGS_SUCCESS,
  ADD_LABREQUESTTRACKING_SUCCESS,
  ADD_LABREQUESTTRACKING_FAIL,
  UPDATE_LABREQUESTTRACKING_SUCCESS,
  UPDATE_LABREQUESTTRACKING_FAIL,
  DELETE_LABREQUESTTRACKING_SUCCESS,
  DELETE_LABREQUESTTRACKING_FAIL,  
  SET_STATE_LABREQUESTTRACKING
} from "./actionTypes";

const INIT_STATE = {
  labRequestTrackings: [],
  labRequestTracking: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestTrackings = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTTRACKINGS_SUCCESS:
      return {
        ...state,
        labRequestTrackings: action.payload.labRequestTrackings,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTTRACKING:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTTRACKINGS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTTRACKING_SUCCESS:
      return {
        ...state,
        labRequestTrackings: [...state.labRequestTrackings, action.payload],
      };

    case ADD_LABREQUESTTRACKING_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTTRACKING_SUCCESS:
      return {
        ...state,
        labRequestTrackings: state.labRequestTrackings.map(labRequestTracking =>
          labRequestTracking.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestTracking }
            : labRequestTracking
        ),
      };

    case UPDATE_LABREQUESTTRACKING_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTTRACKING_SUCCESS:
      return {
        ...state,
        labRequestTrackings: state.labRequestTrackings.filter(
          labRequestTracking => labRequestTracking.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTTRACKING_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTTRACKING_SUCCESS:
      return {
        ...state,
        labRequestTracking: action.payload,
      };

    case GET_LABREQUESTTRACKING_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestTrackings;
